<ng-container *transloco="let t; prefix: 'logout'">
    <div class="container py-5">
        @if (hasError()) {
            <div class="d-flex justify-content-center">
                <div class="content-box" style="max-width: 480px;">
                    <h3>{{ t("error.singlelogout.title") }}</h3>
                    <p class="card-text">{{ t("error.singlelogout.text") }}</p>
                    <button class="btn wp-btn float-end" type="button" (click)="onWelcomeClick()">
                        {{ t("error.singlelogout.button") }}
                    </button>
                </div>
            </div>
        } @else {
            <div class="visually-hidden">{{ t("loadingtext") }}</div>
        }
    </div>
</ng-container>
